<template>
  <i class="j-empty"></i>
</template>

<script>
export default {
  props: {},
  methods: {},
}
</script>
<style lang="less">
.j-empty {
  display: inline-block;
  width: 16px;
  height: 2px;
  background: #eee;
  position: relative;
  top: -4px;
  left: 0px;
  border-radius: 1px;
}

.ant-descriptions-bordered .ant-descriptions-item-content {
  .j-empty {
    left: 3px;
  }
}

.ant-descriptions-bordered .ant-descriptions-item-content .ant-table-row {
  .j-empty {
    left: 0px;
  }
}
</style>
